import { Link } from "react-router-dom";

// The Aegis Line mark: a minimal geometric shield (protection / the aegis)
// crossed at the midpoint by a single horizontal gold rule (the line that
// holds). Abstract, clean, reads at 16px.
export const Logo = ({ className = "" }) => (
    <Link
        to="/"
        data-testid="logo-link"
        className={`group inline-flex items-center gap-3 ${className}`}
        aria-label="The Aegis Line home"
    >
        <svg
            width="26"
            height="26"
            viewBox="0 0 32 32"
            fill="none"
            className="shrink-0"
            aria-hidden="true"
        >
            <path
                d="M8 5 H24 V17 L16 27 L8 17 Z"
                fill="none"
                stroke="#B8892A"
                strokeWidth="2"
                strokeLinejoin="round"
                className="transition-opacity duration-300 group-hover:opacity-80"
            />
            <line
                x1="8"
                y1="14"
                x2="24"
                y2="14"
                stroke="#B8892A"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
        <span className="flex flex-col leading-none">
            <span className="font-display text-[9px] font-medium uppercase tracking-[0.34em] text-text-lo">
                The
            </span>
            <span className="mt-1 font-display text-base font-extrabold uppercase tracking-[0.16em] text-text-hi">
                Aegis Line
            </span>
        </span>
    </Link>
);

export default Logo;
